import Vue from "vue";
import Vuex from "vuex";
import { getUserInfo } from "@/api/user";
import router from "../router";
import {Message} from "element-ui";
import {getUserRole} from "../api/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userType: "",
    fileUrl: process.env.VUE_APP_FILE_URL,
    orgUrl: process.env.VUE_APP_ORG_URL,
    userRole: [],
    login: 1,
    closeLogin: 0,
    findPass: 1,
    token: '',
    userInfo: {}
  },
  getters: {
    hasRole: (state) => (role) => {
      return state.userRole && state.userRole.includes(role);
    }
  },
  actions: {
    getUserInfo(context) {
      return new Promise(resolve => {
        getUserInfo().then(res => {
          if(res.code !== 200) {
            Message.error(res.msg);
            return Promise.reject();
          }
          context.state.userInfo = res.data;
          context.state.login = Date.now();
          context.state.token = localStorage.getItem('dclass_token')
          localStorage.setItem("dclass_user", JSON.stringify(res.data));
          this.dispatch('getUserRole')
        }).catch(() => {
          this.dispatch('logout')
        }).finally(() => {
          resolve()
        })
      })
    },
    getUserRole(context) {
      getUserRole().then(res => {
        context.state.userRole = res.data;
      }).catch(() => {
        context.state.userRole = [];
      })
    },
    logout(context) {
      localStorage.clear();
      context.state.userInfo = {};
      context.state.login = 0;
      router.push('/login');
    }
  },
  modules: {},
});
